import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";

import { getAccessToken } from "Utils/KeycloakWrapper";
import { config } from "../../../config";

let client: AxiosInstance | null = null;
export async function getStorebrandClient(): Promise<AxiosInstance> {
  if (client === null) {
    const baseURL = await getBaseUrl();
    client = axios.create({
      baseURL,
      headers: { ClientId: config.name },
      timeout: 60000,
    });
    registerInterceptors(client);
  }
  return client;
}

async function getBaseUrl(): Promise<string> {
  const response = await axios.get<{ apihome: string }>("/api.json");
  return response.data.apihome;
}

function registerInterceptors(instance: AxiosInstance): void {
  instance.interceptors.request.use(automaticallyAuthorizedRequests);
}

async function automaticallyAuthorizedRequests(
  requestConfig: InternalAxiosRequestConfig,
): Promise<InternalAxiosRequestConfig> {
  if (requestConfig.url?.includes("/open/") ?? true) {
    return requestConfig;
  }

  const token = await getAccessToken();

  requestConfig.headers.set({ Authorization: `Bearer ${token}` });

  return requestConfig;
}
